import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants'

export default (theme: APTheme) => createStyles({
	tableSkeleton: {
		display: 'flex',
		'@media(max-width: 990px)': {
			display: 'block',
		}
	},
	tableSkeletonContainer: {
		flex: 1,
		alignItems: 'center',
		padding: '34px 35px',
		marginRight: 30,
		borderRadius: 3,
		'&:last-child': {
			marginRight: 0,
		},
		'@media(max-width: 1300px)': {
			marginRight: 15,
			'&:last-child': {
				marginRight: 0,
			},
		},
		'@media(max-width: 1200px)': {
			paddingLeft: 110
		},
		'@media(max-width: 990px)': {
			minHeight: 58,
			margin: '0 0 10px 0',
			paddingLeft: 110,
			'&:last-child': {
				marginBottom: 0
			},
		},
		'@media(max-width: 768px)': {
			paddingLeft: 30
		}
	},
	tableContainer: {
		'& > table': {
			border: '1px solid rgba(224, 224, 224, 1)',
			borderBottom: 'none'
		}
	},
	customTableRow: {
		border: '1px solid rgba(224, 224, 224, 1)',
		width: '100%'
	},
	tableHeadingCell: {
		color: '#4A4A4A',
		fontSize: 18,
		fontWeight: 500,
		padding: '18px 4px',
		backgroundColor: '#fff',
		borderBottom: '1px solid rgba(224, 224, 224, 1)',
		'&:first-child': {
			paddingLeft: 15,
		},
		'&:last-child': {
			paddingRight: 15
		}
	},
	tableCell: {
		fontSize: 16,
		padding: '15px 7px',
		'&:first-child': {
			fontWeight: 500,
			paddingLeft: 15
		},
		'&:last-child': {
			paddingRight: 15
		},
		'&:last-child > span': {
			justifyContent: 'flex-end'
		}
	},
	tableBody: {
		backgroundColor: '#ffffff' // TODO - Get hex colour codes from constant style variables
	},
	referralsSearchTableCell: {
		width: 'auto',
		padding: '0',
		position: 'relative',
		fontSize: 14,
		display: 'flex',
		gridTemplateColumns: '10em auto',
		justifyItems: 'stretch',
		border: 'none',
		marginBottom: 5,
		marginLeft: 10,
		'&:before': {
			fontWeight: 500,
		},
		'&:first-child': {
			marginTop: 15,
			paddingLeft: 0
		},
		'&:last-child': {
			marginBottom: 15,
			'& > span': {
				justifyContent: 'flex-start',
			},
		}
	},
	searchDataTableHeadingCellSpan: {
		fontSize: 18,
		fontWeight: 700,
		lineHeight: '25px'
	},
	notificationTableCell: {
		'&:first-child': {
			width: '80%'
		},
		'&:last-child': {
			width: '20%'
		}
	},
	notificationSkeletonContainer: {
		padding: '0px',
	}
});